import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { ShieldCheck, Truck } from 'lucide-react';
export function OfferBox() {
  return <div className="max-w-3xl mx-auto px-4 py-12" data-id="element-77">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="bg-white rounded-3xl shadow-2xl border border-slate-200 overflow-hidden relative" data-id="element-78">
        <div className="bg-brand-700 text-white text-center py-2 text-sm font-bold tracking-widest uppercase" data-id="element-79">
          Begrenztes Angebot
        </div>

        <div className="p-8 sm:p-12 flex flex-col md:flex-row items-center gap-8" data-id="element-80">
          {/* Product Image Area */}
          <div className="w-full md:w-1/2 flex flex-col items-center" data-id="element-81">
            <div className="relative w-full aspect-square bg-slate-50 rounded-2xl flex items-center justify-center p-6 mb-4" data-id="element-82">
              <img src="https://cdn.magicpatterns.com/uploads/ncuLAsFWPVP4N9fiiSaDPX/product.png" alt="Das brillenförmige RYLTE-Gerät" className="w-full h-full object-contain drop-shadow-xl" data-id="element-83" />
              <div className="absolute bottom-4 font-serif font-bold text-2xl text-slate-800 tracking-widest" data-id="element-84">
                RYLTE
              </div>
            </div>
          </div>

          {/* Offer Details Area */}
          <div className="w-full md:w-1/2 flex flex-col items-center text-center" data-id="element-85">
            <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-86">
              Klinik-Technologie für Zuhause
            </h3>
            <p className="text-slate-600 mb-8" data-id="element-87">
              RYLTE kostet weniger als eine einzige Klinik-Sitzung.
            </p>

            <CTAButton className="w-full mb-4" data-id="element-88">
              AUGENSCHATTEN REDUZIEREN
            </CTAButton>

            <div className="flex flex-col gap-2 text-sm text-slate-600 font-medium" data-id="element-89">
              <div className="flex items-center justify-center gap-2" data-id="element-90">
                <ShieldCheck className="w-4 h-4 text-green-600" data-id="element-91" />
                <span data-id="element-92">90-Tage-Geld-zurück-Garantie</span>
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-93">
                <Truck className="w-4 h-4 text-slate-400" data-id="element-94" />
                <span data-id="element-95">Kostenloser Versand im DACH-Raum</span>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>;
}